import { render, staticRenderFns } from "./FamilyAdd.vue?vue&type=template&id=6870c25c"
import script from "./FamilyAdd.vue?vue&type=script&lang=js"
export * from "./FamilyAdd.vue?vue&type=script&lang=js"
import style0 from "./FamilyAdd.vue?vue&type=style&index=0&id=6870c25c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports